import clsx from "clsx";
import { observer } from "mobx-react-lite";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import BriaButton from "../../../../../components/common/BriaButton/BriaButton.tsx";
import { PlaygroundImage } from "../../../../../models/image-to-image";
import styles from "./ImageOverlayRefineButton.module.scss";
import RefineModal from "./RefineModal/RefineModal";

type Props = { image: PlaygroundImage };

const ImageOverlayRefineButton = ({ image }: Props) => {
	const { t } = useTranslation("translation", { keyPrefix: "playground.textToImage.imageOverlay" });
	const [isRefineModalOpen, setIsRefineModalOpen] = useState(false);

	const isTextToImage = image.type === "textToImage";
	const isTgImageGen = image.type === "tgImageGeneration";

	const handleRefineClick = (e: React.MouseEvent) => {
		e.stopPropagation();
		setIsRefineModalOpen(true);
	};

	const handleCloseModal = () => {
		setIsRefineModalOpen(false);
	};

	if (!(isTextToImage || isTgImageGen)) {
		return null;
	}

	return (
		<>
			<BriaButton
				className={clsx(
					styles.refineButton,
					{
						["iconHover"]: true,
					},
					"refineButton",
				)}
				buttonType="primary"
				onClick={handleRefineClick}
			>
				{t("refine.button")}
			</BriaButton>

			{isRefineModalOpen && <RefineModal image={image} onClose={handleCloseModal} />}
		</>
	);
};

export default observer(ImageOverlayRefineButton);
